import { InfoBinesPendientesModel } from "./bin-catalogos.model";

export class ControlSearchAltaResponse {
    public binesPendientes:Array<InfoBinesPendientesModel>;
    constructor(){
        this.binesPendientes = new Array<InfoBinesPendientesModel>();
    }
}